import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PromocodePaginationRequest } from '@portal/models/promocodePaginationRequest';
import LangEnum = PromocodePaginationRequest.LangEnum;

@Injectable({
  providedIn: 'root',
})
export class LangService {
  private readonly translateService = inject(TranslateService);

  // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
  get currentLang(): LangEnum | string {
    return this.translateService && this.translateService.currentLang
      ? this.translateService.currentLang.toUpperCase()
      : LangEnum.EN;
  }
}
